export enum RemoteConfigKeys {
  DemoConfig = 'demo_config',
  AppMinimumVersion = 'app_minimum_version'
}
